import { Alert } from "@jugl-web/ui-kit";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useTranslations } from "@jugl-web/utils";
import { HELP_CENTER_URL } from "@jugl-web/utils/consts";
import workspaceLimitationAnimation from "./assets/workspace-limitation.json";

export type EntityLimitReachedAlertProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const EntityLimitReachedAlert = ({
  isOpen,
  onClose,
}: EntityLimitReachedAlertProps) => {
  const { t } = useTranslations();

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onClose}
      img={
        <Lottie
          options={{ animationData: workspaceLimitationAnimation }}
          height={150}
          width={150}
        />
      }
      title={t({
        id: "entities-page.workspace-limit-reached-title",
        defaultMessage: "You reached Workspace Limit",
      })}
      content={t({
        id: "entities-page.workspace-limit-reached-description",
        defaultMessage:
          "Oh no! Seems like You already created 10 of 10 free Personal Workspaces. You can update your plan to go unlimited ✨",
      })}
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          color: "grey",
          role: "close",
        },
        {
          text: t({
            id: "entities-page.workspace-limit-get-more",
            defaultMessage: "Get More",
          }),
          onClick: () => {
            window.open(`${HELP_CENTER_URL}/en`, "_blank");
            onClose();
          },
        },
      ]}
    />
  );
};
